window.addEventListener('load', function () {
	objectFitImages();
});